import serviceSql from '../service/service.sql';

const ControllerSql = async (db) => {
    try {
        const reqEncounter = await db.exec(`SELECT
            id,
            fight_start,
            local_player,
            current_boss,
            duration,
            total_damage_dealt,
            top_damage_dealt,
            dps,
            misc,
            difficulty,
            cleared    
            FROM encounter`);

        // Fetch data from 'entity' table
        const reqEntity = await db.exec(`SELECT
            name,
            character_id,
            encounter_id,
            npc_id,
            entity_type,
            class_id,
            class,
            gear_score,
            max_hp,
            is_dead,
            damage_stats,
            dps
            FROM entity
            WHERE entity_type = 'PLAYER'`);
        
        // Process the entity data
        const newEntity = reqEntity[0].values.map(curr => {
            const {
                damageDealt,
                damageTaken,
                debuffedBySupport,
                buffedBySupport,
                buffedByIdentity,
                deathTime,
                frontAttackDamage,
                backAttackDamage,
                shieldsGiven,
                shieldsReceived,
                rdpsDamageReceived,
                rdpsDamageReceivedSupport,
                rdpsDamageGiven
            } = JSON.parse(curr[10]);
            return [
                curr[0],
                curr[1],
                curr[2],
                curr[3],
                curr[4],
                curr[5],
                curr[6],
                curr[7],
                curr[8],
                curr[9],
                curr[11],
                damageDealt,
                damageTaken,
                debuffedBySupport,
                buffedBySupport,
                buffedByIdentity,
                deathTime,
                frontAttackDamage,
                backAttackDamage,
                shieldsGiven,
                shieldsReceived,
                rdpsDamageReceived,
                rdpsDamageReceivedSupport,
                rdpsDamageGiven
            ];
        });

        const newEncounter = reqEncounter[0].values.map(curr => {
            const {
                partyInfo
            } = JSON.parse(curr[8]);
            return [
                curr[0],
                curr[1],
                curr[2],
                curr[3],
                curr[4],
                curr[5],
                curr[6],
                curr[7],
                curr[9],
                curr[10],
                partyInfo
            ]
        })

        // Prepare the final data to send
        const listAll = JSON.stringify({
            "entity": newEntity,
            "encounter": newEncounter
        });

        await serviceSql.sendAll(listAll);

        return true;

    } catch (error) {
        console.log("error uploading", error)
    }


}

export default ControllerSql;
